import { create } from 'zustand';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';

const defaultState: OrderNumberStoreState = {
    orderNumber: '',
    isOrderPage: false
}

export interface OrderNumberStoreState {
    orderNumber: string;
    isOrderPage: boolean
}

export interface OrderNumberStoreAction {
    reset: () => void;
}

export const useOrderNumberStore = create<OrderNumberStoreState & OrderNumberStoreAction>()(
    persist(
        (set) => ({
            ...defaultState,
            reset: () => {
                set(() => ({ ...defaultState }))
            }
        }),
        {
            name: 'orderNumberStore',
            storage: createJSONStorage(() => sessionStorage)
        }
    )
)